import React from 'react';
import { usePreferences } from '@/contexts/PreferencesContext';
import * as LucideIcons from 'lucide-react';

// Type for flexible icon names (can be any string)
export type IconName = string;

interface DynamicIconProps {
  name: IconName;
  className?: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const DynamicIcon: React.FC<DynamicIconProps> = ({ 
  name, 
  className = "w-6 h-6", 
  size, 
  color, 
  style,
  onClick 
}) => {
  // Hardcoded mappings for system icons that shouldn't change
  const systemIconMap: Record<string, React.ComponentType<any>> = {
    'home': LucideIcons.Home,
    'notes': LucideIcons.StickyNote,
    'mail': LucideIcons.Mail,
    'store': LucideIcons.Store,
  };
  
  // Check if this is a system icon first
  let Icon = systemIconMap[name];
  
  // If not a system icon, try dynamic resolution
  if (!Icon) {
    // Convert kebab-case to PascalCase for Lucide icon lookup
    const toPascalCase = (str: string) => {
      return str
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
    };
    
    const iconName = toPascalCase(name);
    Icon = (LucideIcons as any)[iconName] as React.ComponentType<any>;
  }
  
  // Fallback to Store icon if not found
  if (!Icon) {
    Icon = LucideIcons.Store;
  }
  
  const iconProps = {
    className: className,
    size: size || 24,
    color: color,
    style: style,
    onClick: onClick,
  };
  
  return <Icon {...iconProps} />;
};

export default DynamicIcon;